import React from "react";
import { Link } from "react-router-dom";
import "../styles/footer.css";
// Path to the GutenStack logo used in the footer
import Logo from "../assets/images/Guten-Stack-stacked-wordmark.webp";

const Footer = () => {
  return (
	<footer className="footer" style={{ position: 'relative', zIndex: 10 }}>
	  <div className="footer-container">
		{/* ✅ Logo Centered */}
		<div className="footer-logo">
		  <Link to="/">
                        <img src={Logo} alt="GutenStack Logo" />
		  </Link>
		</div>

		{/* ✅ Centered Navigation */}
		<nav className="footer-nav">
		  <ul>
			<li><Link to="/">Home</Link></li>
			<li><Link to="/about">About</Link></li>
			<li><Link to="/kpis">KPIs</Link></li>
			<li><Link to="/release-notes">Release Notes</Link></li>
			<li><Link to="/signup">Sign Up</Link></li>
		  </ul>
		</nav>

		{/* ✅ Bottom Section */}
		<div className="footer-bottom">
		  <p className="footer-copyright">Your virtual bookshelf.</p>
		  <p className="footer-copyright">© {new Date().getFullYear()} GutenStack, a division of <Link to="https://beginthework.com">Begin the Work, LLC</Link>.</p>
		  <div className="footer-links">
			<Link to="/terms-of-use">Terms</Link>
			<Link to="/privacy-policy">Privacy</Link>
		  </div>
		</div>
	  </div>
	</footer>
  );
};

export default Footer;